import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-funnels-setting',
  templateUrl: './new-funnels-setting.component.html',
  styleUrls: ['./new-funnels-setting.component.scss']
})
export class NewFunnelsSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
